import { ShippingCarriers } from "../shippingCarriers";
import { ShippingService } from "../shippingRates.types";
import { getPricesWithoutVAT } from "../utils";


export const ebayPacklink_mondialRelay: ShippingService = {
    serviceCode: 'ebayPacklink_mondialRelay',
    description: 'Buying on eBay, through Packlink platform expeditions.ebay.fr',
    appliesVolumetricWeight: false,
    maxDimensions: (size1: number, size2: number, size3: number, weight: number) => {
        if (weight >= 25000) {
            return { isValid: false, errorMessage: 'Max weight exceeded (25kg).' };
        }
        const calculation = size1 + size2 + size3;
        if (calculation > 150) {
            return { isValid: false, errorMessage: 'Max dimensions exceeded (150cm). Calculation is Length + Width + Height' };
        }
        return { isValid: true, errorMessage: '' };
    },
    deliveryType: 'pickup',
    carrier: ShippingCarriers.mondial_relay,
    conditions: {
        orderPlatform: 'ebay',
    },
    externalMappings: {
        ebay: {
            carrierCode: 'MondialRelay',
            serviceCode: 'FR_LivraisonEnRelaisMondialRelay',
            serviceCodeInternational: 'FR_OtherInternational',
        },
    },
    ratesByDestination: [
        {
            destinations: ['FR', 'LU', 'BE'],
            rates: [
                {
                    minWeight: 0,
                    maxWeight: 500,
                    ...getPricesWithoutVAT(2.5),
                },
                {
                    minWeight: 500,
                    maxWeight: 1000,
                    ...getPricesWithoutVAT(3.33),
                },
                {
                    minWeight: 1000,
                    maxWeight: 2000,
                    ...getPricesWithoutVAT(4.58),
                },
                {
                    minWeight: 2000,
                    maxWeight: 4000,
                    ...getPricesWithoutVAT(5.42),
                },
                {
                    minWeight: 4000,
                    maxWeight: 5000,
                    ...getPricesWithoutVAT(6.24),
                },
                {
                    minWeight: 5000,
                    maxWeight: 10000,
                    ...getPricesWithoutVAT(7.91),
                },
                {
                    minWeight: 10000,
                    maxWeight: 15000,
                    ...getPricesWithoutVAT(12.08),
                },
                {
                    minWeight: 15000,
                    maxWeight: 20000,
                    ...getPricesWithoutVAT(14.58),
                },
            ],
        },

        /* Other destinations are not available on expeditions.ebay.fr */

        // {
        //     destinations: ['IT'],
        //     rates: [
        //         {
        //             minWeight: 0,
        //             maxWeight: 500,
        //             ...getPricesWithoutVAT(3.28),
        //         },
        //         {
        //             minWeight: 500,
        //             maxWeight: 1000,
        //             ...getPricesWithoutVAT(4.33),
        //         },
        //         {
        //             minWeight: 1000,
        //             maxWeight: 2000,
        //             ...getPricesWithoutVAT(5.15),
        //         },
        //         {
        //             minWeight: 2000,
        //             maxWeight: 4000,
        //             ...getPricesWithoutVAT(6.73),
        //         },
        //         {
        //             minWeight: 4000,
        //             maxWeight: 5000,
        //             ...getPricesWithoutVAT(7.77),
        //         },
        //         {
        //             minWeight: 5000,
        //             maxWeight: 10000,
        //             ...getPricesWithoutVAT(9.95),
        //         },
        //         {
        //             minWeight: 10000,
        //             maxWeight: 15000,
        //             ...getPricesWithoutVAT(15.29),
        //         },
        //         {
        //             minWeight: 15000,
        //             maxWeight: 20000,
        //             ...getPricesWithoutVAT(18.52),
        //         },
        //     ],
        // },
        // {
        //     destinations: ['DE'],
        //     rates: [
        //         {
        //             minWeight: 0,
        //             maxWeight: 500,
        //             ...getPricesWithoutVAT(4.65),
        //         },
        //         {
        //             minWeight: 500,
        //             maxWeight: 1000,
        //             ...getPricesWithoutVAT(4.98),
        //         },
        //         {
        //             minWeight: 1000,
        //             maxWeight: 2000,
        //             ...getPricesWithoutVAT(7.50),
        //         },
        //         {
        //             minWeight: 2000,
        //             maxWeight: 4000,
        //             ...getPricesWithoutVAT(8.90),
        //         },
        //         {
        //             minWeight: 4000,
        //             maxWeight: 5000,
        //             ...getPricesWithoutVAT(9.63),
        //         },
        //         {
        //             minWeight: 5000,
        //             maxWeight: 10000,
        //             ...getPricesWithoutVAT(13.50),
        //         },
        //         {
        //             minWeight: 10000,
        //             maxWeight: 15000,
        //             ...getPricesWithoutVAT(18.79),
        //         },
        //         {
        //             minWeight: 15000,
        //             maxWeight: 20000,
        //             ...getPricesWithoutVAT(24.28),
        //         },
        //     ],
        // },
        // {
        //     destinations: ['ES'],
        //     rates: [
        //         {
        //             minWeight: 0,
        //             maxWeight: 500,
        //             ...getPricesWithoutVAT(3.85),
        //         },
        //         {
        //             minWeight: 500,
        //             maxWeight: 1000,
        //             ...getPricesWithoutVAT(4.90),
        //         },
        //         {
        //             minWeight: 1000,
        //             maxWeight: 2000,
        //             ...getPricesWithoutVAT(5.70),
        //         },
        //         {
        //             minWeight: 2000,
        //             maxWeight: 4000,
        //             ...getPricesWithoutVAT(7.28),
        //         },
        //         {
        //             minWeight: 4000,
        //             maxWeight: 5000,
        //             ...getPricesWithoutVAT(8.40),
        //         },
        //         {
        //             minWeight: 5000,
        //             maxWeight: 10000,
        //             ...getPricesWithoutVAT(10.65),
        //         },
        //         {
        //             minWeight: 10000,
        //             maxWeight: 15000,
        //             ...getPricesWithoutVAT(16.26),
        //         },
        //         {
        //             minWeight: 15000,
        //             maxWeight: 20000,
        //             ...getPricesWithoutVAT(19.63),
        //         },
        //     ],
        // },
        // {
        //     destinations: ['PT'],
        //     rates: [
        //         {
        //             minWeight: 0,
        //             maxWeight: 500,
        //             ...getPricesWithoutVAT(6.24),
        //         },
        //         {
        //             minWeight: 500,
        //             maxWeight: 1000,
        //             ...getPricesWithoutVAT(6.84),
        //         },
        //         {
        //             minWeight: 1000,
        //             maxWeight: 2000,
        //             ...getPricesWithoutVAT(9.57),
        //         },
        //         {
        //             minWeight: 2000,
        //             maxWeight: 4000,
        //             ...getPricesWithoutVAT(11.17),
        //         },
        //         {
        //             minWeight: 4000,
        //             maxWeight: 5000,
        //             ...getPricesWithoutVAT(13.63),
        //         },
        //         {
        //             minWeight: 5000,
        //             maxWeight: 10000,
        //             ...getPricesWithoutVAT(16.09),
        //         },
        //         {
        //             minWeight: 10000,
        //             maxWeight: 15000,
        //             ...getPricesWithoutVAT(19.68),
        //         },
        //         {
        //             minWeight: 15000,
        //             maxWeight: 20000,
        //             ...getPricesWithoutVAT(29.25),
        //         },
        //     ],
        // },
        // {
        //     destinations: ['NL'],
        //     rates: [
        //         {
        //             minWeight: 0,
        //             maxWeight: 500,
        //             ...getPricesWithoutVAT(4.38),
        //         },
        //         {
        //             minWeight: 500,
        //             maxWeight: 1000,
        //             ...getPricesWithoutVAT(4.38),
        //         },
        //         {
        //             minWeight: 1000,
        //             maxWeight: 2000,
        //             ...getPricesWithoutVAT(4.38),
        //         },
        //         {
        //             minWeight: 2000,
        //             maxWeight: 4000,
        //             ...getPricesWithoutVAT(5.38),
        //         },
        //         {
        //             minWeight: 4000,
        //             maxWeight: 5000,
        //             ...getPricesWithoutVAT(6.63),
        //         },
        //         {
        //             minWeight: 5000,
        //             maxWeight: 7000,
        //             ...getPricesWithoutVAT(8.25),
        //         },
        //         {
        //             minWeight: 7000,
        //             maxWeight: 10000,
        //             ...getPricesWithoutVAT(11),
        //         },
        //         {
        //             minWeight: 10000,
        //             maxWeight: 15000,
        //             ...getPricesWithoutVAT(14.96),
        //         },
        //         {
        //             minWeight: 15000,
        //             maxWeight: 20000,
        //             ...getPricesWithoutVAT(14.96),
        //         },
        //     ],
        // },
    ],
}